<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{ responseError }}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="Code"
                  label="Material Session Code"
                  v-model="materialSession.code"
                  type="text"
                  :rules="rules.codeRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="Name"
                  label="Material Session Name"
                  v-model="materialSession.name"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>

              <v-flex sm12>
                <v-text-field
                  name="Description"
                  label="Description"
                  v-model="materialSession.description"
                  type="text"
                  :rules="rules.descriptionRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="materialSession.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="materialSession.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="materialSession.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="materialSession.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="materialSession.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="materialSession.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="materialSession.id">
                <v-switch
                  :label="`Status is ${statusFlag ? 'Active' : 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid || saveLoading"
                    type="submit"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";
import { MaterialSessionFormRules } from "../../helpers/validation-rules";
import { materialSessionService } from "../../services/material-session-service";
import { MaterialSession } from "../../models/model";

export default {
  name: "MaterialSessionDetail",
  components: { VSwitch },
  data: () => ({
    valid: true,
    saveLoading: false,
    breadcrumbs: [
      {
        text: "Material Session",
        disabled: false,
        to: "material-sessions",
      },
      {
        text: "Material Session Detail",
        disabled: true,
      },
    ],
    rules: new MaterialSessionFormRules(),
    materialSession: new MaterialSession(),
    oldmaterialSession: new MaterialSession(),
    createdDate: "",
    updatedDate: "",
    responseError: "",
    statusFlag: true,
  }),
  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      // new
    } else {
      this.getMaterialSessionDetail(id);
    }
  },
  methods: {
    getMaterialSessionDetail(id) {
      materialSessionService.getMaterialSessionDetail(id).then((res) => {
        this.materialSession = res.data;
        this.createdDate = commonService.millisecondToDate(
          this.materialSession.createdDateInMilliSeconds,
          "YYYY-MM-DD"
        );
        this.updatedDate = commonService.millisecondToDate(
          this.materialSession.updatedDateInMilliSeconds,
          "YYYY-MM-DD"
        );
        this.oldmaterialSession = Object.assign({}, res.data);
        this.statusFlag =
          this.materialSession.status == "ACTIVE" ? true : false;
      });
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (!this.saveLoading) {
          this.saveLoading = true;
          this.materialSession.status = this.statusFlag ? "ACTIVE" : "INACTIVE";
          materialSessionService
            .saveMaterialSession(this.materialSession)
            .then((res) => {
              console.log(res);
              this.goBack();
            })
            .catch((err) => {
              console.log(err);
              if (err.response.data) {
                this.responseError = err.response.data.message;
              }
              this.saveLoading = false;
            });
        }
      }
    },
    clear() {
      this.$refs.form.resetValidation();
      this.responseError = "";
      if (!this.materialSession.id) {
        this.materialSession = new MaterialSession();
        this.statusFlag = true;
      } else {
        this.materialSession = Object.assign({}, this.oldmaterialSession);
        this.statusFlag =
          this.materialSession.status == "ACTIVE" ? true : false;
      }
    },
    goBack() {
      this.$router.push("/material-sessions");
    },
  },
};
</script>
